import '../../utils/index.mjs';
import _sfc_main from './src/check-tag2.mjs';
export { checkTagEmits, checkTagProps } from './src/check-tag.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElCheckTag = withInstall(_sfc_main);

export { ElCheckTag, ElCheckTag as default };
//# sourceMappingURL=index.mjs.map
